import { render, staticRenderFns } from "./SolutionRatingsComponent.vue?vue&type=template&id=0e756671&scoped=true"
import script from "./SolutionRatingsComponent.vue?vue&type=script&lang=js"
export * from "./SolutionRatingsComponent.vue?vue&type=script&lang=js"
import style0 from "./SolutionRatingsComponent.vue?vue&type=style&index=0&id=0e756671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e756671",
  null
  
)

export default component.exports